import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import AddEmployeeModal from "./AddEmployeeModal";
import AppButton from "../common/AppButton";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const NoEmployeeListFound: React.FC = () => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh"
      }}
    >
      <Typography variant="h5" fontWeight="bold" mb={2}>
        {t("employee-list-not-found-title", "No Employee Found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "employee-list-not-found-description",
          "It looks like there are no employees in your inventory yet."
        )}
        <br />
        {t(
          "employee-list-not-found-cta-hint",
          "Click below to add your first employee."
        )}
      </Typography>

      <Box>
        <AppButton variant="primary" onClick={() => setOpenAddModal(true)}>
          {t("employee-add-new", "Add new employee")}
        </AppButton>
      </Box>

      {/* Modal directly inside component */}
      <AddEmployeeModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
    </Box>
  );
};

export default NoEmployeeListFound;
